import React, { useEffect, useState } from "react";
import AllChatbot from "../../All_Chatbot/AllChatbot";
import { HomeOwner } from "../../../Utils/Constant";
import PaginationComponent from "../../Pagination/pagination";
import { formatDate } from "../../../Utils/LetterCase";
import folder_icon from "../../../images/folder-icon.svg";
import SubmitUpdate from "../Updates/SubmitUpdate";
import FactCheck from "../Updates/FactCheck";
import { useDispatch } from "react-redux";
import { getAllDocuments } from "../../../Services/DocumentUpload/documentUploadApi";
import { useParams } from "react-router-dom";
import { decryptId } from "../../../Utils/Crypto";

const Document = ({ publicData, privateData, communityName, comData }) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const { encryptedId } = useParams();
  const id = decryptId(encryptedId);
  const [pubPage, setPubPage] = useState(1);
  const [pubPageSize, setPubPageSize] = useState(10);
  const [pubCount, setPubCount] = useState(0);
  const [priPage, setPriPage] = useState(1);
  const [priPageSize, setPriPageSize] = useState(10);
  const [priCount, setPriCount] = useState(0);

  useEffect(() => {
    dispatch(
      getAllDocuments({
        community_id: id,
        page: pubPage,
        page_size: pubPageSize,
        access: "public",
      })
    ).unwrap();
    if (userId)
      dispatch(
        getAllDocuments({
          community_id: id,
          page: priPage,
          page_size: priPageSize,
          access: "private",
          user_id: userId,
        })
      ).unwrap();
    setPubCount(publicData.count);
    setPriCount(privateData.count);
  }, [
    dispatch,
    id,
    priPage,
    priPageSize,
    privateData.count,
    pubPage,
    pubPageSize,
    publicData.count,
    userId,
  ]);

  const handleViewFile = (fileUrl) => {
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    } else {
      console.error("File URL is missing!");
    }
  };

  const getFileNameFromUrl = (url) => {
    const path = new URL(url).pathname; // Get the path from the URL
    return path.split("/").pop(); // Split the path by '/' and get the last element (filename)
  };

  const handleDownloadFile = async (url) => {
    try {
      // Fetch the file
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const file_name = getFileNameFromUrl(url);

      // Convert the file into a Blob
      const blob = await response.blob();

      // Create a temporary URL for the blob
      const blobUrl = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger a download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = file_name; // Specify the file name for download
      document.body.appendChild(a);
      a.click();

      // Clean up the URL and remove the anchor element
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="tab-content">
      <div className="public-docs">
        <div className="d-flex justify-content-between align-items-center heading-buttons-block">
          <div className="tab-titles">Public Documents</div>
          {userId != null ? (
            <></>
          ) : (
            <div className="tab-btns-block d-flex">
              <SubmitUpdate comData={comData} />
              <FactCheck />
            </div>
          )}
        </div>
        {publicData?.data?.length ? (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th className="col-60 ps-0">File Name</th>
                  <th className="col-60 ps-0">Date</th>
                  <th className="col-40 ps-0">Actions</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {publicData?.data?.map((doc, index) => (
                  <tr key={doc?.id}>
                    <td>
                      <div className="d-flex me-2">
                        <div className="me-2 file-name-block">
                          <img src={folder_icon} alt="folder"></img>
                        </div>{" "}
                        <div>{doc?.document_name}</div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex me-2">
                        <div>{formatDate(doc?.version_date)}</div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex table-icons">
                        <div
                          className="view-icon"
                          onClick={() =>
                            handleViewFile(doc?.community_documents || "")
                          }
                        >
                          <svg
                            width="23"
                            height="14"
                            viewBox="0 0 23 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.1287 6.97774L11.1292 6.97822C11.29 7.15599 11.5005 7.21609 11.653 7.238C11.8105 7.26063 11.9753 7.25258 12.1231 7.23601C12.3885 7.20623 12.693 7.13639 12.9567 7.07594C12.9844 7.06957 13.0118 7.0633 13.0386 7.05719C13.2354 7.01232 13.3997 6.97706 13.5311 6.95653C13.3767 7.90443 12.5338 8.643 11.5 8.643C10.3535 8.643 9.44355 7.73647 9.44355 6.64282C9.44355 5.63673 10.2137 4.789 11.2295 4.65971C11.2081 4.7656 11.1739 4.89965 11.1282 5.06578C11.1201 5.0956 11.1115 5.12633 11.1028 5.1578C11.0345 5.40465 10.9533 5.69753 10.915 5.96132C10.893 6.1126 10.8804 6.2814 10.9006 6.44683C10.9207 6.61263 10.9784 6.81103 11.1287 6.97774ZM11.2546 4.43357C11.2546 4.43349 11.2549 4.43504 11.2552 4.43845C11.2546 4.43536 11.2545 4.43365 11.2546 4.43357ZM0.519273 6.7003C0.509678 6.67229 0.504714 6.65347 0.502196 6.6427C0.504713 6.6319 0.509688 6.61297 0.519334 6.58478C0.540183 6.52384 0.575496 6.4408 0.629216 6.33645C0.736448 6.12817 0.904162 5.85984 1.13575 5.55124C1.5982 4.93501 2.29758 4.18182 3.22894 3.45212C5.08908 1.99474 7.85829 0.642822 11.5 0.642822C15.1411 0.642822 17.9103 1.99473 19.7706 3.45213C20.7021 4.18184 21.4016 4.93504 21.8641 5.55127C22.0957 5.85988 22.2635 6.12821 22.3708 6.3365C22.4245 6.44084 22.4598 6.52388 22.4807 6.58482C22.4903 6.61298 22.4953 6.6319 22.4978 6.6427C22.4953 6.65347 22.4903 6.67228 22.4807 6.70027C22.4599 6.76111 22.4246 6.84407 22.3708 6.94836C22.2636 7.15652 22.0958 7.42478 21.8641 7.73336C21.4016 8.34952 20.7021 9.10281 19.7706 9.83267C17.9103 11.2904 15.1411 12.6428 11.5 12.6428C7.85835 12.6428 5.08915 11.2904 3.22897 9.83268C2.29761 9.10283 1.5982 8.34955 1.13573 7.73339C0.904125 7.42482 0.736396 7.15657 0.629154 6.9484C0.575428 6.84412 0.540116 6.76115 0.519273 6.7003ZM5.88825 6.64282C5.88825 9.69076 8.41118 12.142 11.5 12.142C14.589 12.142 17.1106 9.69061 17.1106 6.64282C17.1106 3.59533 14.5893 1.1413 11.5 1.1413C8.41087 1.1413 5.88825 3.59519 5.88825 6.64282Z"
                              stroke="#414141"
                            />
                          </svg>
                        </div>
                        <div
                          className="delete-icon"
                          onClick={() =>
                            handleDownloadFile(doc?.community_documents)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="23"
                            height="18"
                            viewBox="0 0 32 32"
                            className=""
                          >
                            <g>
                              <path
                                fill="#212121"
                                d="M30 29a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h26a1 1 0 0 1 1 1zm-14.71-4.29a1 1 0 0 0 1.42 0l8-8a1 1 0 0 0-1.42-1.42L17 21.59V3a1 1 0 0 0-2 0v18.59l-6.29-6.3a1 1 0 1 0-1.42 1.42z"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <PaginationComponent
              count={pubCount}
              pageSize={pubPageSize}
              setPageSize={setPubPageSize}
              page={pubPage}
              setPage={setPubPage}
            />
          </div>
        ) : (
          <td colSpan="5">No Public Documents Found For This Community</td>
        )}
      </div>
      <div className="private-docs">
        <div className="d-flex justify-content-between align-items-center heading-buttons-block">
          {!userType || userType === HomeOwner ? (
            <></>
          ) : (
            <div className="tab-titles">Private Documents</div>
          )}
        </div>
        {privateData?.data?.length ? (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th className="col-60 ps-0">File Name</th>
                  <th className="col-60 ps-0">Date</th>
                  <th className="col-40 ps-0">Actions</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {privateData?.data?.map((doc, index) => (
                  <tr key={doc?.id}>
                    <td>
                      <div className="d-flex me-2">
                        <div className="me-2 file-name-block">
                          <img src={folder_icon} alt="folder"></img>
                        </div>
                        <div>{doc?.document_name}</div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex me-2">
                        <div>{formatDate(doc?.version_date)}</div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex table-icons">
                        <div
                          className="view-icon"
                          onClick={() =>
                            handleViewFile(doc?.community_documents || "")
                          }
                        >
                          <svg
                            width="23"
                            height="14"
                            viewBox="0 0 23 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.1287 6.97774L11.1292 6.97822C11.29 7.15599 11.5005 7.21609 11.653 7.238C11.8105 7.26063 11.9753 7.25258 12.1231 7.23601C12.3885 7.20623 12.693 7.13639 12.9567 7.07594C12.9844 7.06957 13.0118 7.0633 13.0386 7.05719C13.2354 7.01232 13.3997 6.97706 13.5311 6.95653C13.3767 7.90443 12.5338 8.643 11.5 8.643C10.3535 8.643 9.44355 7.73647 9.44355 6.64282C9.44355 5.63673 10.2137 4.789 11.2295 4.65971C11.2081 4.7656 11.1739 4.89965 11.1282 5.06578C11.1201 5.0956 11.1115 5.12633 11.1028 5.1578C11.0345 5.40465 10.9533 5.69753 10.915 5.96132C10.893 6.1126 10.8804 6.2814 10.9006 6.44683C10.9207 6.61263 10.9784 6.81103 11.1287 6.97774ZM11.2546 4.43357C11.2546 4.43349 11.2549 4.43504 11.2552 4.43845C11.2546 4.43536 11.2545 4.43365 11.2546 4.43357ZM0.519273 6.7003C0.509678 6.67229 0.504714 6.65347 0.502196 6.6427C0.504713 6.6319 0.509688 6.61297 0.519334 6.58478C0.540183 6.52384 0.575496 6.4408 0.629216 6.33645C0.736448 6.12817 0.904162 5.85984 1.13575 5.55124C1.5982 4.93501 2.29758 4.18182 3.22894 3.45212C5.08908 1.99474 7.85829 0.642822 11.5 0.642822C15.1411 0.642822 17.9103 1.99473 19.7706 3.45213C20.7021 4.18184 21.4016 4.93504 21.8641 5.55127C22.0957 5.85988 22.2635 6.12821 22.3708 6.3365C22.4245 6.44084 22.4598 6.52388 22.4807 6.58482C22.4903 6.61298 22.4953 6.6319 22.4978 6.6427C22.4953 6.65347 22.4903 6.67228 22.4807 6.70027C22.4599 6.76111 22.4246 6.84407 22.3708 6.94836C22.2636 7.15652 22.0958 7.42478 21.8641 7.73336C21.4016 8.34952 20.7021 9.10281 19.7706 9.83267C17.9103 11.2904 15.1411 12.6428 11.5 12.6428C7.85835 12.6428 5.08915 11.2904 3.22897 9.83268C2.29761 9.10283 1.5982 8.34955 1.13573 7.73339C0.904125 7.42482 0.736396 7.15657 0.629154 6.9484C0.575428 6.84412 0.540116 6.76115 0.519273 6.7003ZM5.88825 6.64282C5.88825 9.69076 8.41118 12.142 11.5 12.142C14.589 12.142 17.1106 9.69061 17.1106 6.64282C17.1106 3.59533 14.5893 1.1413 11.5 1.1413C8.41087 1.1413 5.88825 3.59519 5.88825 6.64282Z"
                              stroke="#414141"
                            />
                          </svg>
                        </div>
                        <div
                          className="delete-icon"
                          onClick={() =>
                            handleDownloadFile(doc?.community_documents)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="23"
                            height="18"
                            viewBox="0 0 32 32"
                            className=""
                          >
                            <g>
                              <path
                                fill="#212121"
                                d="M30 29a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h26a1 1 0 0 1 1 1zm-14.71-4.29a1 1 0 0 0 1.42 0l8-8a1 1 0 0 0-1.42-1.42L17 21.59V3a1 1 0 0 0-2 0v18.59l-6.29-6.3a1 1 0 1 0-1.42 1.42z"
                                opacity="1"
                              />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <PaginationComponent
              count={priCount}
              pageSize={priPageSize}
              setPageSize={setPriPageSize}
              page={priPage}
              setPage={setPriPage}
            />
          </div>
        ) : !userType || userType === HomeOwner ? (
          <></>
        ) : (
          <td colSpan="5">No Private Documents Found For This Community</td>
        )}
      </div>
      <AllChatbot communitName={communityName} />
    </div>
  );
};

export default Document;
